import Modal from "react-bootstrap/Modal";
import React, { useEffect, useState } from "react";
import QRCode from "qrcode";

const ShareEventModal = ({ onHide, show, event_link }) => {
    const [isCopied, setIsCopied] = useState(false);
    const [qrcode, setQrcode] = useState('');

    useEffect(() => {
        generateQRCode()
    }, [show])

    const handleCopyLink = () => {
        navigator.clipboard.writeText(event_link)
        setIsCopied(true)
    }

    if (isCopied) {
        setTimeout(() => {
            setIsCopied(false)
        }, 1000)
    }

    const generateQRCode = () => {
        QRCode.toDataURL(
            event_link,
            {
                width: 256,
                margin: 2
            },
            (err, url) => {
                if (err) return console.log(err)
                setQrcode(url)
            }
        )
    }

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header className="py-3 px-4" closeButton>
                <Modal.Title>
                    Bagikan acaramu
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="py-3 px-4">
                <div className="my-3">
                    <img src={qrcode} className="border p-1 rounded-3" style={{ width: '100%', maxWidth: '256px' }} />
                </div>
                <div style={{
                    color: '#656566',
                    // font responsive
                    fontSize: '14px',
                    lineHeight: '20px',
                    fontWeight: '400',
                    textAlign: 'center',
                    wordBreak: 'break-word',
                }}>
                    {event_link}
                </div>
            </Modal.Body>
            <Modal.Footer className="py-3 px-4">
                <div className="w-100 d-flex flex-column flex-md-row gap-3">
                    {isCopied ? (
                        <p className="btn btn-outline-blue btn-cancel shadow-none w-100 mb-0">
                            Link berhasil disalin
                        </p>
                    ) : (
                        <button
                            className="btn btn-outline-red btn-cancel shadow-none w-100"
                            onClick={handleCopyLink}
                        >
                            Salin Link
                        </button>
                    )}
                    <a
                        href={qrcode}
                        download={'qrcode-event.png'}
                        className="btn btn-main-blue btn-confirm shadow-none w-100"
                    >
                        Download QR
                    </a>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ShareEventModal;
